import React, { Component } from "react";
import { List, Button } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { add_to_basket, remove_from_basket } from "../redux/actions/basket";
import { connect } from "react-redux";

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q: "",
      dataLoading: false,
    };

    this.getData = this.getData.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }
  async getData() {
    this.setState(
      {
        dataLoading: true,
      },
      async () => {}
    );
  }

  addItem(item) {
    const { dispatch } = this.props;
    dispatch(add_to_basket(item));
  }

  removeItem(item) {
    const { dispatch } = this.props;
    dispatch(remove_from_basket(item));
  }

  getItemAmount(uid) {
    const { basket } = this.props;
    let amount = 0;
    for (let i = 0; i < basket.length; i++) {
      if (basket[i].uid === uid) {
        amount = basket[i].amount;
      }
    }
    return amount;
  }

  render() {
    const { data } = this.props;
    return (
      <div>
        <List
          size="large"
          dataSource={data}
          style={{fontSize: 16}}
          renderItem={(item, idx) => (
            <List.Item
              style={{
                borderBottom:
                  idx === data.length - 1 ? undefined : "1px solid grey",
              }}
              actions={[
                <Button
                  type="success"
                  shape="circle"
                  size="small"
                  onClick={() => this.addItem({ ...item, amount: 1 })}
                >
                  <PlusOutlined />
                </Button>,
                <span> {this.getItemAmount(item.uid)}</span>,
                <Button
                  type="danger"
                  shape="circle"
                  size="small"
                  onClick={() => this.removeItem(item)}
                >
                  <MinusOutlined />
                </Button>,
              ]}
            >
              {item.name}
            </List.Item>
          )}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { basket: state.basket.basket };
}

export default connect(mapStateToProps)(ItemList);
